import { RootState } from '../../Store';
import { useSelector } from 'react-redux';

export const useGetFilterValues = (): string[] =>
    useSelector<RootState, string[]>(state => state.pdf.filterValues);

export const useGetFilterValuesSelected = (): string[] =>
    useSelector<RootState, string[]>(state => state.pdf.filterValuesSelected);
